import Qs from 'qs'
import FetchFactory from '../factory'

interface IReadNotification {
  params: {
    media_id: string | number
  }
}

interface INotifications {
  query: {
    page: number
    limit: number
  }
}

class NotificationModule extends FetchFactory<any> {
    async getNotifications(payload: INotifications) {
        const { query } = payload
        return await useAsyncData(() => {
            return super.call(`/api/notifications?${Qs.stringify(query)}`, {
                method: 'GET',
      })
        })
    }

    async readNotification(payload: IReadNotification) {
        const { params } = payload
        return await useAsyncData(() => {
            return super.call(`/api/notifications/${params.id}/read`, {
                method: 'POST',
      })
        })
    }

    async readAllNotification() {
        return await useAsyncData(() => {
            return super.call('/api/notifications/read-all', {
                method: 'POST',
      })
        })
    }

    async getUnreadNotification() {
        return await useAsyncData(() => {
            return super.call('/api/notifications/information')
        })
    }
}

export default NotificationModule
